import { Card, CardContent } from '@jq4race/ui';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Card className="border-border bg-card">
      <CardContent className="flex flex-col items-center gap-4 px-6 py-12 text-center">
        {Icon ? (
          <div className="rounded-full bg-accent/10 p-3.5 text-jq-gold-bright ring-1 ring-accent/30">
            <Icon className="size-6" strokeWidth={1.5} />
          </div>
        ) : null}
        <div className="space-y-1">
          <p className="jq-h5 text-foreground">{title}</p>
          {description ? <p className="jq-body-sm text-muted-foreground">{description}</p> : null}
        </div>
        {action ? <div>{action}</div> : null}
      </CardContent>
    </Card>
  );
}
